import type { ModuleMigrationDef } from "@kubdee/sdk";

export const migration: ModuleMigrationDef = {
  key: "003_add_default_ai_mode",
  version: "1.1.0",
  sql: `
ALTER TABLE \`chat_settings\` ADD COLUMN \`default_ai_mode_enabled\` integer DEFAULT 0 NOT NULL;
`,
};
